import Keycloak from "keycloak-js";

// Setup Keycloak instance as needed
const keycloak = Keycloak({
  url: "http://localhost:8000/auth",
  realm: "devs",
  clientId: "hvs-ui",
});

export default keycloak;
